module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-01-m-en.ab1b6421e42cda1a774043b7fa6f3aa0.png";